import { ChangeEvent, useState } from "react";
import { Form } from "react-bootstrap";
import TextField from "@components/FormsV2/TextField/TextField";
import type { PaymentCreditFormValues } from "../types";

export interface PaymentCreditFormProps {
  id: string;
  initialValues: PaymentCreditFormValues;
  isSubmitting: boolean;
  onSubmit: (values: PaymentCreditFormValues) => void;
}

export const PaymentCreditForm = ({
  id,
  initialValues,
  isSubmitting,
  onSubmit,
}: PaymentCreditFormProps): JSX.Element => {
  const [values, setValues] = useState<PaymentCreditFormValues>(initialValues);

  const set = <K extends keyof PaymentCreditFormValues>(
    key: K,
    v: PaymentCreditFormValues[K]
  ) => setValues((prev) => ({ ...prev, [key]: v }));

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (isSubmitting) return;
    onSubmit(values);
  };

  return (
    <Form id={id} data-testid={id} onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-6">
          <Form.Label htmlFor="payment-credit-source">
            Payment Source
          </Form.Label>
          <TextField
            label={null}
            id="payment-credit-source"
            value={values.paymentSource}
            placeholder="Vendor or reason for credit"
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              set("paymentSource", e.target.value)
            }
            required
          />
        </div>
        <div className="col-sm-6">
          <Form.Label htmlFor="payment-credit-description">
            Description
          </Form.Label>
          <TextField
            label={null}
            id="payment-credit-description"
            value={values.description}
            placeholder="Description of credit or program"
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              set("description", e.target.value)
            }
            required
          />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-12">
          <Form.Group className="mb-3">
            <Form.Label htmlFor="payment-credit-criteria">Criteria</Form.Label>
            <Form.Control
              id="payment-credit-criteria"
              as="textarea"
              rows={5}
              value={values.criteria}
              placeholder="Criteria a customer must meet to receive this credit"
              onChange={(e) => set("criteria", e.target.value)}
            />
          </Form.Group>
        </div>
      </div>
    </Form>
  );
};

export default PaymentCreditForm;
